'use client';

import React from 'react';
import CopyToClipboard from '@/components/atoms/CopyToClipboard';
import { CouponProps } from './types';
const Coupon = ({
  discountCode,
  discountLabel
}: CouponProps) => {
  return <div className="my-6 rounded-md border border-dashed border-primary-300 bg-primary-100 py-4" data-sentry-component="Coupon" data-sentry-source-file="index.tsx">
      <p className="mb-2 text-center text-body-8 font-semibold text-gray-500">{discountLabel}</p>
      <div className="flex justify-center text-h5 text-primary-600">
        <CopyToClipboard text={discountCode} className="flex items-center gap-x-2 hover:text-primary-500" classNameText="text-center text-h5 font-bold" classNameIcon="w-4 h-4" data-sentry-element="CopyToClipboard" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
export default Coupon;